import apiClient from "./apiClient";

const fallBackCompanyInfo  = {
  name: "Softition",
  logoUrl: "/uploads/images/company/logo.png",
  shortDesc: "We don’t just build technology — we craft experiences that connect, engage, and inspire.",
  footerText: "© 2025 Softition. Designed with passion, powered by innovation.",
  logo: "logo.png",
  contact: {
    address: "Plot No-1015, Buxi Bazar Rd, Sutahat, Cuttack, Odisha 753001",
    phone: "+91 7787868607",
    email: "contact@softition.com",
    quote:"“Every great collaboration starts with a conversation.”",
  },
  mapUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3737.73188995065!2d85.87450497460327!3d20.476202281038407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a191277014ded79%3A0x4a9fe61aa7be44cb!2sSoftition%20Solutions!5e0!3m2!1sen!2sin!4v1755133702513!5m2!1sen!2sin",
};

const fallBackSocialLinks = [
  { platform: "facebook", icon:"FaFacebookF", url: "https://www.facebook.com/softition" },
  { platform: "twitter", icon:"FaTwitter", url: "https://x.com/softition" },
  { platform: "linkedin", icon:"FaLinkedinIn", url: "https://www.linkedin.com/company/softition/" },
  { platform: "instagram", icon:"FaInstagram", url: "https://www.instagram.com/softitionsolutions/" },
];

const fallBackNavLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Projects", path: "/projects" },
  { label: "Contact", path: "/contact" },
];

const fallBackQuickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];

const fallBackourStory  = {
    title: "Our Story",
    paragraphs: [
      "Founded with a vision to bridge the gap between ideas and execution, Softition has been a trusted partner for businesses worldwide. Our journey began with a small but passionate team determined to create meaningful digital solutions.",

      "Today, we proudly deliver projects that combine cutting-edge technology, elegant design, and measurable results. Our mission remains simple — empower businesses to thrive in a digital-first world.",
    ],
    image: "our-story.png",
}
  
const fallBackCoreBeliefs = [
  {
    title: "Our Mission",
    text: "Deliver innovative, scalable, and secure digital solutions that help businesses grow and adapt to the evolving market.",
  },
  {
    title: "Our Vision",
    text: "To become a global leader in digital transformation, setting benchmarks in creativity, quality, and customer satisfaction.",
  },
  {
    title: "Our Values",
    text: "Integrity, innovation, collaboration, and commitment — the guiding principles in every project we take on.",
  },
];

  const fallBackAboutWhoWeAre = {
    title: "Who We Are!",
    description: "Softition is a modern software studio focused on delivering scalable, efficient, and elegant software solutions tailored to your needs.",
    linkText: "Learn More",
    link: "/about"
  };

const fallBackCTA = {
  title: "Ready to Transform Your Business?",
  subtitle:"From concept to completion, we’re here to bring your vision to life.",
  buttonText: "Contact Us",
  buttonLink: "/contact",
  bgColor:""
};

const fallBackFinalCTA = {
  title: "Ready to build something great together?",
  subtitle:"",
  buttonText: "Let’s Talk",
  buttonLink: "/contact",
  bgColor:"#5B7C99"
};

const fallBackHero= {
    messages: [
      "Empowering Your Digital Journey",
      "Innovating Custom Software Solutions",
      "Transforming Ideas into Reality",
    ],
    description: "Custom solutions to streamline your modern business operations",
    linkText: "Let’s Talk",
    link: "/contact",
    bgColor: "#5B7C99",
};
  
export const getCompanyInfo = async () => {
  try {
    const response = await apiClient.get("/company");
    return response.data;
  } catch (error) {
    console.error("Error fetching company info:", error);
      //throw error;
      return fallBackCompanyInfo ;
  }
};

export const getNavLinks = async () => {
  try {
    const response = await apiClient.get("/nav-links");
    return response.data;
  } catch (error) {
      console.error("Error fetching nav links:", error);
      //throw error; // rethrow so component can handle it
      return fallBackNavLinks;
  }
};

export const getQuickLinks = async () => {
  try {
    const response = await apiClient.get("/quick-links");
    return response.data;
  } catch (error) {
      console.error("Error fetching quick links:", error);
      //throw error; // rethrow so component can handle it
      return fallBackQuickLinks;
  }
};

export const getSocialLinks = async () => {
  try {
    const response = await apiClient.get("/social-links");
    return response.data;
  } catch (error) {
    console.error("Error fetching social links:", error);
    //throw error; // rethrow so component can handle it
    return fallBackSocialLinks;
  }
};

export const getOurStory = async () => {
  try {
    const response = await apiClient.get("/our-story");
    return response.data;
  } catch (error) {
    console.error("Error fetching our story:", error);
    //throw error; // rethrow so component can handle it
    return fallBackourStory;
  }
};

export const getCoreBeliefs = async () => {
  try {
    const response = await apiClient.get("/our-story");
    return response.data;
  } catch (error) {
    console.error("Error fetching our story:", error);
    //throw error; // rethrow so component can handle it
    return fallBackCoreBeliefs;
  }
};

export const getCTA = async () => {
  try {
    const response = await apiClient.get("/cta");
    return response.data;
  } catch (error) {
    console.error("Error fetching CTA:", error);
    //throw error; // rethrow so component can handle it
    return fallBackCTA;
  }
};

export const getFinalCTA = async () => {
  try {
    const response = await apiClient.get("/final-cta");
    return response.data;
  } catch (error) {
    console.error("Error fetching Final CTA:", error);
    //throw error; // rethrow so component can handle it
    return fallBackFinalCTA;
  }
};

export const getAboutWhoWeAre = async () => {
  try {
    const response = await apiClient.get("/who-we-are");
    return response.data;
  } catch (error) {
    console.error("Error fetching who we are:", error);
    //throw error; // rethrow so component can handle it
    return fallBackAboutWhoWeAre;
  }
};

export const getHero = async () => {
  try {
    const response = await apiClient.get("/hero");
    return response.data;
  } catch (error) {
    console.error("Error fetching hero:", error);
    //throw error; // rethrow so component can handle it
    return fallBackHero;
  }
};
